import React from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ButtonBox from './ButtonBox';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
// import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ButtonCustom from '../Button/ButtonCustom';
import { STATUS } from '../../constants/form-status';
import { ACTION } from '../../constants/form-action';
import { Paper } from '@mui/material';


const ButtonContainer = ({ btnAction, activeStep, steps, getStepContent, action , formStatus , isAgentRestricted }) => {

    const btnIncomplete = () => {

        return (
            <React.Fragment>
                {/* {(!isAgentRestricted) &&  */}
                {activeStep !== 2 && //not equal to upload page.
                    <ButtonCustom
                        color="inherit"
                        variant="text"
                        label={"Back"}
                        disabled={activeStep === 0}
                        sx={{ mr: 1 }}
                        startIcon={<ChevronLeftRoundedIcon />}
                        onClickBtn={() => btnAction.handleBack()}
                    />
                }
               

                <Box sx={{ flex: '1 1 auto' }} />
                {
                    (((activeStep === steps.length - 1) || activeStep === 0))
                        &&
                        formStatus !== STATUS.SUBMITTED
                        ?
                        <>
                            {action !== ACTION.VIEW ?
                                <>
                                    {formStatus === STATUS.INCOMPLETE &&
                                        <ButtonCustom
                                            onClickBtn={() => btnAction.handleCancel()}
                                            label={"Cancel"}
                                            endIcon={<CancelOutlinedIcon />}
                                            sx={{ mr: 1 }}
                                            color="error"
                                        />
                                    }
                                    {formStatus !== STATUS.INCOMPLETE &&
                                        <ButtonCustom
                                            onClickBtn={() => btnAction.handleSaveAsDraft()}
                                            label={"Save as Draft"}
                                            endIcon={<SaveOutlinedIcon />}
                                            sx={{ mr: 1 }}
                                        />
                                    }
                                    <ButtonCustom
                                        onClickBtn={() => btnAction.handleSubmitNext('SUBMIT')}
                                        // label={activeStep === 0 ? "Submit & Next" : "Save"}
                                        label={activeStep === 0 ? formStatus === STATUS.INCOMPLETE ? "Save" : "Next" : "Save"}
                                        endIcon={activeStep === 0 ? <ChevronRightRoundedIcon /> : <SaveOutlinedIcon />}
                                        variant='contained'
                                    />
                                </>
                                :
                                <>
                                    {activeStep === 1 &&
                                        <>
                                            <ButtonCustom
                                                onClickBtn={() => btnAction.handleSubmitNext('SUBMIT')}
                                                label={"Save as draft"}
                                                endIcon={<SaveOutlinedIcon />}
                                                variant='outlined'
                                                sx={{ mr: 1 }}
                                            />
                                            
                                        </>
                                    }

                                    {activeStep === 0 &&
                                    <>
                                        <ButtonCustom
                                            onClickBtn={() => btnAction.handleUpdate()}
                                            label={"Update"}
                                            endIcon={<EditNoteOutlinedIcon />}
                                            sx={{ mr: 1 }}
                                        />
                                        <ButtonCustom
                                            onClickBtn={() => btnAction.handleSubmitNext('NEXT')}
                                            label={"Next"}
                                            endIcon={<ChevronRightRoundedIcon />}
                                        />
                                    </>

                                    }
                                    {/* {!isAgentRestricted && activeStep === 1 && */}
                                    { activeStep === 1 && 
                                        <ButtonCustom
                                            // onClickBtn={() => btnAction.handleSubmitNext(STATUS.SUBMITTED)}
                                            // label={"Submit To Accounts"}
                                            onClickBtn={() => btnAction.handleSubmitNext('SUBMIT_DOWNLOAD')}
                                            label={"Save and Download All"}
                                            variant='contained'
                                            endIcon={<DownloadOutlinedIcon />}
                                        />
                                    }

                                </>
                            }
                        </>
                        :
                        <>
                            {activeStep === 0 &&
                                <ButtonCustom
                                    onClickBtn={() => btnAction.handleSubmitNext('NEXT')}
                                    label={"Next"}
                                    endIcon={<ChevronRightRoundedIcon />}
                                />
                            }
                            {(activeStep === 2 && formStatus !== STATUS.SUBMITTED ) &&
                                <ButtonCustom
                                    onClickBtn={() => btnAction.handleSubmitNext(STATUS.SUBMITTED)}
                                    label={"Submit To Accounts"}
                                    // onClickBtn={() => btnAction.handleSubmitNext('SUBMIT')}
                                    variant='contained'
                                    endIcon={<ChevronRightRoundedIcon />}
                                />
                            }
                        </>
                }
            </React.Fragment>
        )
    }

    const btnReset = () => {
        return (
            <ButtonCustom
                onClickBtn={() => btnAction.handleReset()}
                label={"Review the form/s"}
            />
        
        )
    }

    return (
        // <React.Fragment>

        //     {activeStep === steps.length ? (
        //         <React.Fragment>
        //             <Typography sx={{ mt: 2, mb: 1 }}>
        //                 All steps completed - you're finished
        //             </Typography>
        //             <ButtonBox>
        //                 {/* {btnReset()} */}
        //             </ButtonBox>
        //         </React.Fragment>
        //     ) : (
                <React.Fragment>
                    {getStepContent(activeStep)}
                    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, pb:2, pr:1, zIndex: 9999 }} elevation={3} >
                        <ButtonBox>
                            {btnIncomplete()}
                        </ButtonBox>
                    </Paper>


                </React.Fragment>
        //     )}
        // </React.Fragment>
    )
}

export default ButtonContainer;